import OspreyCommunication from './communication-get'

export default class Communication {

    getAll() {
      return new OspreyCommunication()
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/communication/index.js